import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { ReportEffects } from "./report.effects";
import { reportReducer } from "./report.reducer";

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature("report", reportReducer),
        EffectsModule.forFeature([ReportEffects]),
    ],
    providers: []
})
export class ReportStateModule { }
